import React from "react";
import ReactDOM from "react-dom";
import { getCookie, hasCookie } from '@insight/toolkit-utils/lib/helpers/cookieHelpers'
import {
  fetchSearchSuggestions,
  getCachedAemMenuItems,
  getCachedFilteredItemsMap,
  getHeaderInformation,
  getLoggedInFilterMap,
  getTranslations,
  getCustomCatalogData
} from "api";
import {getFeatureFlags, getFreshHeaderInformation} from './api/us'
import {IPS_CONTRACT_NAME_COOKIE_NAME, IPS_CONTRACT_ID_COOKIE_NAME} from './api/us/constants'

import "./scss/index.scss";
import Header from "./components/Header";
import { HeaderInfoContextProvider } from "./context/HeaderInfoContext";
import { updateShoppingRequestWithUser, syncShoppingRequest, syncShoppingRequestFromGuest } from "./libs/helpers";

Promise.resolve(getHeaderInformation()).then((headerInfo) => {
  return Promise.all([
    getTranslations(headerInfo),
    getCachedAemMenuItems(),
    getCachedFilteredItemsMap(
      headerInfo.isLoggedIn ? headerInfo.userInformation.email : "loggedOut"
    ),
    getCustomCatalogData(),
    getFeatureFlags(),
      // headerInfo.isLoggedIn && syncShoppingRequestFromGuest()
    ])
  })
  .then(([headerInfo, cachedAemMenuItems, cachedFilteredItemMap, customCatalogData, featureFlags]) => {
    const element = document.getElementById("app-header");
    const { isCES, isIPSUser, isLoggedIn, userInformation } = headerInfo;
    const loginContract = isIPSUser && isLoggedIn ? userInformation?.contract : null
    // Logout contract details
    const ipsContractID = hasCookie(IPS_CONTRACT_ID_COOKIE_NAME) ? getCookie(IPS_CONTRACT_ID_COOKIE_NAME): null
    const ipsContractName = hasCookie(IPS_CONTRACT_NAME_COOKIE_NAME) ? getCookie(IPS_CONTRACT_NAME_COOKIE_NAME): null
    const logoutContract =  isIPSUser && ipsContractID && !isLoggedIn ? {
      contractType: decodeURIComponent(decodeURIComponent(ipsContractName)),
      contractId: ipsContractID
    } : null

    const contract = isIPSUser ? (loginContract || logoutContract) : null

    ReactDOM.render(
      <HeaderInfoContextProvider 
        initialHeaderInfo={headerInfo}
        onHeaderInfoRefresh={getFreshHeaderInformation}
      >
        <Header
          cachedAemMenuItems={cachedAemMenuItems}
          cachedFilteredItemMap={cachedFilteredItemMap}
          headerInfo={headerInfo}
          contract={contract}
          isCES={isCES}
          customCatalogData={customCatalogData}
          featureFlags={featureFlags}
        />
      </HeaderInfoContextProvider>
      ,
      element
    );
    if (headerInfo.isLoggedIn) {
      document.body.classList.add("is-logged-in");
    }
    if (headerInfo.isCES) {
      document.body.classList.add("is-ces");
      syncShoppingRequest(headerInfo).then((data) => {
        if (data) {
          updateShoppingRequestWithUser(headerInfo).then(() => syncShoppingRequestFromGuest(headerInfo))
        }
      })
    }
    else {
      syncShoppingRequestFromGuest(headerInfo)
    }
  });

export default { getLoggedInFilterMap };
export { fetchSearchSuggestions };
